import { ReactComponent as ThankYouSvg } from "@/assets/illustrations/thank-you.svg";
import { ReactComponent as BannerSvg } from "@/assets/illustrations/home-banner.svg";

export const ThankYouPage = () => {
  return (
    <div className="relative container mx-auto">
      <div className="absolute -z-10">
        <BannerSvg className="hidden md:block md:w-full 2xl:min-w-[1384px] h-auto" />
      </div>

      <div className="flex flex-col items-center gap-8 lg:px-10 lg:gap-20 lg:my-20">
        <ThankYouSvg className="w-full" />

        <div className="text-center text-lg lg:text-2xl max-w-2xl font-light">
          Thank you for becoming a member of the T12 family. We can tell you are
          someone who is serious about building the startup of your dreams and
          we are here to support you.
        </div>

        <div className="flex flex-col gap-4 w-full max-w-screen-sm mx-auto">
          <div className="h-px w-full bg-[#7B7B7B]" />
          <div className="font-light">
            <div className="text-secondary text-lg lg:text-2xl text-center">
              Please check your email.
            </div>
          </div>
          <div className="h-px w-full bg-[#7B7B7B]" />
        </div>
      </div>
    </div>
  );
};
